import { Component, NgZone, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { AdvtService } from '../../../_services/advt.service';
import { AlertService } from '../../../_services';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Http } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';


@Component({
  selector: 'app-post-graphics-home',
  templateUrl: './post-graphics-home.component.html',
  styleUrls: ['./post-graphics-home.component.css']
})
export class PostGraphicsHomeComponent implements OnInit {
  @ViewChild('template') template: TemplateRef<any>;


  // Modal
  modalRef: BsModalRef;

  public listItem;
  public listSingleItem;
  category_id = 2;
  public seller_id;
  pageSize = 9;
  pageNo = 1;
  totalPage = [1];
  del = false;
  public searchSubmit = false;
  listLength: any;
  loading: boolean = false;
  mainLoader;
  NAP;
  is_seller;
  is_seller_status: Boolean = false;
  modal_message;
  dismesUp: Boolean = false;
  item_id;
  delete_model = false;
  showButton: Boolean = false;



  constructor(private fb: FormBuilder,
    private advtService: AdvtService,
    private alertService: AlertService,
    private modalService: BsModalService,
    private router: Router,
    private http: Http) { }


  ngOnInit() {
    this.mainLoader = '../../assets/images/BigLoader.gif';
    this.NAP = '../../assets/images/nap.jpg';
    if (localStorage.getItem('currentUser')) {
      const userInfo = JSON.parse(localStorage.getItem('currentUser'));
      this.seller_id = userInfo.result.id;
      this.is_seller = userInfo.result.is_seller;

    }
    this.ListItems(this.seller_id, this.category_id);

  }

  /**
   * Function to get List
   * @param seller_id 
   * @param category_id 
   */
  public ListItems(seller_id, category_id) {
    this.loading = true;
    var limit = this.pageSize;
    var offset = 0;
    this.advtService.getListItems(this.seller_id, this.category_id, limit, offset)
      .subscribe(data => {
        this.listItem = data.result;
        this.listLength = data.count;
        this.loading = false;

      }, error => {
        this.alertService.error(error);
      });
  }

  /**
 * 
 *function to open model 
 */
  openModal(template: TemplateRef<any>, id) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-md' })
    );
    if (this.delete_model == false) {
      let item_id = id;
      this.advtService.getSingleItem(this.seller_id, item_id)
        .subscribe(data => {
          this.listSingleItem = data;
        }, error => {
          this.alertService.error(error);
        });
    }
  }



  /**
   * This function is used for pagination
   * @param data
   */
  pagingAgent(data) {
    this.loading = true;
    this.searchSubmit = true;
    this.listItem = [];
    this.pageNo = (data * this.pageSize) - this.pageSize;
    this.pageNo = (data * this.pageSize) - this.pageSize;
    var limit = this.pageNo;
    var offset = this.pageNo;

    this.searchSubmit = true;
    this.listItem = [];
    this.advtService.getListItems(this.seller_id, this.category_id, limit, offset).subscribe((data) => {
      this.listItem = data.result;
      this.searchSubmit = false;
      this.loading = false;

    });
  }

  public checkSeller(id) {
    if (this.is_seller === 0) {
      this.is_seller_status = true;
      if(!this.dismesUp){
        this.modal_message = 'You are not Registered as seller? If you want to post ad, Upgrade to seller';
      }
      this.openModal(this.template, id);
    } else {
      this.router.navigate(['./graphics-list/post-graphics']);
    }
  }

  public makeSeller(event: any) {
    this.loading = true;
    this.advtService.makeSeller(this.seller_id).subscribe((res) => {
      if (res.status === 200) {
        if(res['redirect_to_stripe'] == 1){
            window.location.href = environment.stripeurl+res['result']['id'];
          }else{
            this.router.navigate(['./graphics-list/post-graphics']);
          }
        this.loading = false;
        if(res['show_message']){
          this.dismesUp = true;
          this.modal_message = res['message'];
          this.showButton = true;
        }else{
         /* this.router.navigate(['./graphics-list/post-graphics']);
          this._hidemodal(); 
          let resUpdated = JSON.parse(localStorage.getItem('currentUser'));
          resUpdated.result.is_seller = 1;
          localStorage.removeItem("currentUser");
          localStorage.setItem("currentUser", JSON.stringify(resUpdated));*/
        }
        
      }
    });
  }

  /**
  * function to Disbale Modal
  * @param event 
  */
  public _hidemodal() {
    this.modalRef.hide();

  }

  /**
   * function to cancel popup
   */
  public disposePop() {
    this._hidemodal();
    this.router.navigate(['./graphics-list']);
  }


  public Delete_model(id) {
    this.item_id = id;
    this.delete_model = true;
    this.openModal(this.template, id);
  }

  public deleteItem(i) {
    this._hidemodal();
    this.advtService.deleteItem(this.seller_id, this.item_id).subscribe((res) => {
      if (res.status === 200) {
        this.ngOnInit();
        this.alertService.success('Item Deleted Successfully');
        this.listItem.splice(i, 1);
      } if (res.status === 400) {
        this.alertService.warning('Deletion Failed');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/authorized-data/post-graphics-listing/post-graphics-home/post-graphics-home.component.ts